export default "__VITE_ASSET__DLVDrdpC__"